<template>
  <el-input :value="fileName" readonly unselectable="on" :style="`width: ${width}`" :disabled="disabled">
    <i slot="suffix" class="el-input__icon el-icon-circle-close"
       v-show="fileName" @click="deleteFile" style="cursor: pointer" title="删除"></i>
    <el-upload
      :disabled="disabled"
      slot="append"
      ref="fileUpload"
      :accept="tips"
      action="/"
      :show-file-list="false"
      :limit="1"
      :auto-upload="false"
      :multiple="false"
      :on-change="fileChange"
      :on-exceed="exceed"
    >
      <el-button size="small" class="upload-select">选择</el-button>
    </el-upload>
  </el-input>
</template>

<script>
  export default {
    name: "UploadFile",
    model: {
      event: 'change',
    },
    props: {
      suffix: {
        type: String,
        default: ""
      },
      width: {
        type: String,
        default: "100%",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      value: [String, File]
    },
    data() {
      return {
        fileName: this.value,
        tips: "",
      }
    },
    created() {
      let list = (this.suffix + "").split("|");
      list.forEach((item, index) => {
        this.tips += `.${item}`;
        index !== list.length - 1 && (this.tips += ",");
      });
    },
    methods: {
      exceed() {
        this.msgWarning("只能上传一个文件");
      },
      fileChange(file) {
        let name = file.name;
        let suffix = name.slice(name.lastIndexOf("."), name.length);
        let reg = new RegExp(`.${this.suffix}`);
        if (!reg.test(suffix)) {
          this.msgWarning(`文件后缀只能为${this.tips.replaceAll(",", "、")}`);
          this.$refs["fileUpload"].clearFiles();
          return false;
        }
        this.fileName = name;
        this.$emit("change", file.raw);
      },
      deleteFile() {
        this.openConfirm("删除"+this.fileName, () => {
          this.fileName = "";
          this.$emit("change", "");
          this.$refs["fileUpload"].clearFiles();
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  .el-input {
    &.is-disabled {
      .upload-select {
        cursor: not-allowed;
      }
    }
  }
</style>
